



































import {Component, Prop, PropSync, Vue} from 'vue-property-decorator'
import {
    DxTextBox
} from 'devextreme-vue/ui/text-box';
import {
    DxValidator,
    DxRequiredRule,
    DxEmailRule,
    DxStringLengthRule,
    DxPatternRule,
    DxCustomRule
} from 'devextreme-vue/validator';

@Component({
    name: 'DTextbox',
    components: {
        DxTextBox,
        DxValidator,
        DxRequiredRule,
        DxEmailRule,
        DxStringLengthRule,
        DxPatternRule,
        DxCustomRule
    }
})
export default class extends Vue {

    @PropSync('inputData') synceInputData!: string
    @Prop({default: ''}) public title!: string;
    @Prop({default: 'text'}) public textboxMode!: string;
    @Prop({default: 'underlined'}) public stylingMode!: string;
    @Prop({default: false}) public isRequired!: boolean;
    @Prop({default: false}) public isEmail!: boolean;
    @Prop({default: false}) public isReadOnly!: boolean;
    @Prop({default: false}) public disabled!: boolean;
    @Prop() public minLength!: number;
    @Prop() public regularExpression!: string;
    @Prop({default: ''}) public regexValidationError!: string;
    @Prop({default: ''}) public placeholder!: string;
    @Prop({default: false}) public showClearButton!: boolean;
      // Убирает нижнее подчеркивание для селектбоксов
    @Prop({default: false}) public hideUnderLine!: boolean;
    @Prop({required: false}) private customRule: Function;
    @Prop({default: ''}) public customMessage!: string;


    created() {
    }

    public focus(): void {
      const textbox = (this.$refs.textbox as any).instance;
      textbox.focus();
    }

    public getInputInstance(): HTMLInputElement | null {
      const container = (this.$refs.textbox as any).instance.element() as HTMLElement;
      const inputs = container.getElementsByTagName('input');
      return inputs ? inputs[0] : null;
    }
}
